import React from "react";
import {
  LayoutDashboard, Search, FileText, Briefcase, MessageSquare, Wallet, User,
  Bell, ScrollText, AlertOctagon, LineChart, Send, Home, MoreHorizontal,
} from "lucide-react";

export const studentNav = [
  { key: "dash",     to: "/student",              end: true, label: "Dashboard",       icon: LayoutDashboard },
  { key: "find",     to: "/student/tasks",        label: "Find tasks",                 icon: Search },
  { key: "apps",     to: "/student/applications", label: "Applications",               icon: FileText, badge: 3 },
  { key: "alloc",    to: "/student/allocated",    label: "Allocated tasks",            icon: Briefcase },
  { key: "work",     to: "/workroom",             label: "Workroom",                   icon: MessageSquare, badge: 1 },
  { key: "direct",   to: "/student/direct-work",  label: "Direct work",                icon: Send },
  { key: "earn",     to: "/student/earnings",     label: "Earnings",                   icon: Wallet },
  { key: "disputes", to: "/disputes",             label: "Disputes",                   icon: AlertOctagon },
  { key: "profile",  to: "/student/profile",      label: "Profile",                    icon: User },
  { key: "notif",    to: "/notifications",        label: "Notifications",              icon: Bell },
];

export const companyNav = [
  { key: "dash",     to: "/company",              end: true, label: "Dashboard",  icon: LayoutDashboard },
  { key: "post",     to: "/company/post",         label: "Post task",             icon: FileText },
  { key: "tasks",    to: "/company/tasks",        label: "My tasks",              icon: Briefcase },
  { key: "students", to: "/company/students",     label: "Allocated students",    icon: User },
  { key: "work",     to: "/workroom",             label: "Workrooms",             icon: MessageSquare },
  { key: "pay",      to: "/company/payments",     label: "Payments",              icon: Wallet },
  { key: "disputes", to: "/disputes",             label: "Disputes",              icon: AlertOctagon },
  { key: "profile",  to: "/company/profile",      label: "Profile",               icon: User },
  { key: "notif",    to: "/notifications",        label: "Notifications",         icon: Bell },
];

export const adminNav = [
  { key: "overview",  to: "/admin",              end: true, label: "Overview",     icon: LayoutDashboard },
  { key: "analytics", to: "/admin/analytics",    label: "Analytics",               icon: LineChart },
  { key: "direct",    to: "/admin/direct-work",  label: "Direct work",             icon: Send },
  { key: "students",  to: "/admin/students",     label: "Students",                icon: User },
  { key: "companies", to: "/admin/companies",    label: "Companies",               icon: Briefcase },
  { key: "kyc",       to: "/admin/kyc",          label: "KYC verification",        icon: FileText, badge: 27 },
  { key: "gst",       to: "/admin/gst",          label: "GST verification",        icon: FileText, badge: 14 },
  { key: "tasks",     to: "/admin/tasks",        label: "Tasks",                   icon: Briefcase, badge: 9 },
  { key: "apps",      to: "/admin/applications", label: "Applications",            icon: FileText },
  { key: "alloc",     to: "/admin/allocation",   label: "Allocations",             icon: MessageSquare },
  { key: "work",      to: "/workroom",           label: "Workrooms",               icon: MessageSquare },
  { key: "pay",       to: "/admin/payments",     label: "Payments",                icon: Wallet },
  { key: "disputes",  to: "/admin/disputes",     label: "Disputes",                icon: AlertOctagon },
  { key: "audit",     to: "/admin/audit",        label: "Audit logs",              icon: ScrollText },
];

// Compact 5-tab mobile bottom navs
export const studentBottomNav = [
  { key: "home",   to: "/student",             end: true, label: "Home",    icon: Home },
  { key: "tasks",  to: "/student/tasks",       label: "Tasks",              icon: Search },
  { key: "work",   to: "/workroom",            label: "Work",               icon: Briefcase },
  { key: "chat",   to: "/student/direct-work", label: "Chat",               icon: MessageSquare },
  { key: "profile",to: "/student/profile",     label: "Profile",            icon: User },
];

export const companyBottomNav = [
  { key: "home",    to: "/company",          end: true, label: "Home",     icon: Home },
  { key: "tasks",   to: "/company/tasks",    label: "Tasks",               icon: Briefcase },
  { key: "work",    to: "/workroom",         label: "Workroom",            icon: MessageSquare },
  { key: "pay",     to: "/company/payments", label: "Payments",            icon: Wallet },
  { key: "profile", to: "/company/profile",  label: "Profile",             icon: User },
];

export const adminBottomNav = [
  { key: "home",    to: "/admin",             end: true, label: "Dashboard", icon: Home },
  { key: "users",   to: "/admin/students",    label: "Users",                icon: User },
  { key: "tasks",   to: "/admin/tasks",       label: "Tasks",                icon: Briefcase },
  { key: "direct",  to: "/admin/direct-work", label: "Direct",               icon: Send },
  { key: "more",    to: "/admin/audit",       label: "More",                 icon: MoreHorizontal },
];

export const bottomNavFor = (role) =>
  role === "student" ? studentBottomNav :
  role === "company" ? companyBottomNav :
  role === "admin"   ? adminBottomNav   : [];
